import DomainException from '~/modules/Exceptions/Domain/DomainException'

export default class RelationDomainException extends DomainException {
  public static relationNotLoadedException = 'relation_not_loaded'

  public static notLoaded (): RelationDomainException {
    return new RelationDomainException(
      'Relation is not loaded',
      this.relationNotLoadedException)
  }
}
